import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pattern-library/buttons';
import Modal from '@pattern-library/modal';
import { sendAnalyticsEvent } from '../../utils/analytics';

const propTypes = {
    triggerButtonLabel: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    continueButtonLabel: PropTypes.string,
    message: PropTypes.string.isRequired,
    isPending: PropTypes.bool,
    analytics: PropTypes.string
};

const defaultProps = {
    isPending: false
};

function ManagedAccountWarningModal({ analytics, triggerButtonLabel, header, continueButtonLabel, message, isPending }) {
    const [isModalActive, setIsModalActive] = useState(false);
    const triggerButtonRef = useRef();

    const onButtonClick = () => {
        setIsModalActive(true);
    };
    
    const handleContinue = () => {
        sendAnalyticsEvent(analytics);
    };

    const footerChilden = isPending ? undefined : (
        <a className="asc-btn asc-btn--small" href="/participant/managedaccount/plan" onClick={handleContinue}>
            {continueButtonLabel}
        </a>
    );
    return (
        <>
            <Button
                clickHandler={onButtonClick}
                className="asc-btn--small asc-mb-2"
                text={triggerButtonLabel}
                buttonRef={triggerButtonRef}
            />
            <Modal
                id="managed-account-warning-modal"
                headerText={header}
                closeModal={() => setIsModalActive(false)}
                hasFooter
                isActive={isModalActive}
                triggerButtonRef={triggerButtonRef}
                hasFooterClose={isPending}
                footerCloseButtonText={continueButtonLabel}
                footerCloseButtonClasses='asc-btn--small'
                widthClassNames="asc-col-9"
                footerChildren={footerChilden}
            >
                <div dangerouslySetInnerHTML={{__html: message}} />
            </Modal>
        </>
    );
}

ManagedAccountWarningModal.propTypes = propTypes;
ManagedAccountWarningModal.defaultProps = defaultProps;
export default ManagedAccountWarningModal;
